import { takeLatest } from 'redux-saga/effects';
import * as ActionTypes from './ActionTypes';
import {
    AddTaxDeclaration,
    GetEmployeeProfile,
    GetTaxDeclaration,
    UpdateTaxDeclaration,
    AddSalaryComponent,
    AddSalaryStructure,
    DeleteSalaryComponent,
    DeleteSalaryStructure,
    GetSalaryComponent,
    GetSalaryComponentType,
    GetSalaryStructure,
    UpdateSalaryComponent,
    UpdateSalaryStructure,
    GetEarningComponent,
    GetDeductionComponent,
    GetPayrollTemplate,
    AddPayrollTemplate,
    UpdatePayrollTemplate,
    DeletePayrollTemplate,
    GetEmployeeTemplate,
    AddEmployeeTemplate,
    UpdateEmployeeTemplate,
    GetWageReport,
    GetEmployeeTime,
    GetEmployeeFaceTime,
    AddLWF,
    UpdateLWF,
    DeleteLWF,
    GetOT,
    AddOT,
    UpdateOT,
    DeleteOT,
    CalculateEmployeeSalaryTemplate,
    AddCalculateEmployeeSalaryTemplate,
    GetCalculateEmployeeSalaryTemplate,
    GetPayrollSettings,
    GetPayDate,
    UpdatePayDate,
    GetTaxDeclarationExecutive,
    UpdateTaxDeclarationExecutive,
    GetTaxEmployeeToggleInfo,
    UpdateTaxEmployeeToggleInfo,
    GetWageReportNotProcessed,
    GetLeaveWage,
    AddLeaveWage,
    UpdateLeaveWage,
    DeleteLeaveWage,
    GetTransportAllowance,
    AddTransportAllowance,
    UpdateTransportAllowance,
    DeleteTransportAllowance,
    GetPHAllowance,
    AddPHAllowance,
    UpdatePHAllowance,
    GetBonusConfiguration,
    UpdateBonusConfiguration,
    DeletePHAllowance,
    GetFoodAllowance,
    UpdateFoodAllowance,
    GetPostAdjustmentComponents,
    AddPostAdjustmentComponents,
    UpdatePostAdjustmentComponents,
    DeletePostAdjustmentComponents,
    GetPayrollReportingEmployee,
    GetEmployeePostAdjustment,
    AddEmployeePostAdjustment,
    UpdateEmployeePostAdjustment,
    GetDailyWageReport,
    GetDailyWageReportNotProcessed,
    DeleteEmployeePostAdjustment,
    GetExpenseType,
    AddExpenseType,
    UpdateExpenseType,
    DeleteExpenseType,
    GetExpenseSubtype,
    AddExpenseSubtype,
    UpdateExpenseSubtype,
    DeleteExpenseSubtype,
    GetEmployeeExpense,
    AddEmployeeExpense,
    UpdateEmployeeExpense,
    DeleteEmployeeExpense,
    GetApproverExpense,
    UpdateApproverExpense,
    GetPayrollApprover,
    UpdatePayrollApprover,
    GetPayrollTileView,
    GetEmployeeExpenseCsv,
    GetRegistrationNumber,
    AddRegistrationNumber,
    GetCustomEarningComponent,
    GetCustomDeductionComponent,
    GetECMSComponents,
    AddECMSComponents,
    UpdateECMSComponents,
    DeleteECMSComponents,
    GetEmployeeEcmsAdjustment,
    AddEmployeeEcmsAdjustment,
    UpdateEmployeeEcmsAdjustment,
    DeleteEmployeeEcmsAdjustment,
    GetContractualWageReport,
    GetContractualWageReportNotProcessed,
} from './FinanceSaga';

export default function* FinanceWatcher() {
    yield takeLatest(ActionTypes.TAX_DECLARATION_GET_REQUEST, GetTaxDeclaration);
    yield takeLatest(ActionTypes.TAX_DECLARATION_ADD_REQUEST, AddTaxDeclaration);
    yield takeLatest(ActionTypes.TAX_DECLARATION_UPDATE_REQUEST, UpdateTaxDeclaration);
    yield takeLatest(ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_REQUEST, GetTaxDeclarationExecutive);
    yield takeLatest(ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_REQUEST, UpdateTaxDeclarationExecutive);
    yield takeLatest(ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_REQUEST, GetTaxEmployeeToggleInfo);
    yield takeLatest(ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_REQUEST, UpdateTaxEmployeeToggleInfo);
    yield takeLatest(ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_REQUEST, GetEmployeeProfile);
    yield takeLatest(ActionTypes.SALARY_STRUCTURE_GET_REQUEST, GetSalaryStructure);
    yield takeLatest(ActionTypes.SALARY_STRUCTURE_ADD_REQUEST, AddSalaryStructure);
    yield takeLatest(ActionTypes.SALARY_STRUCTURE_UPDATE_REQUEST, UpdateSalaryStructure);
    yield takeLatest(ActionTypes.SALARY_STRUCTURE_DELETE_REQUEST, DeleteSalaryStructure);
    yield takeLatest(ActionTypes.SALARY_COMPONENT_GET_REQUEST, GetSalaryComponent);
    yield takeLatest(ActionTypes.SALARY_COMPONENT_ADD_REQUEST, AddSalaryComponent);
    yield takeLatest(ActionTypes.SALARY_COMPONENT_UPDATE_REQUEST, UpdateSalaryComponent);
    yield takeLatest(ActionTypes.SALARY_COMPONENT_DELETE_REQUEST, DeleteSalaryComponent);
    yield takeLatest(ActionTypes.SALARY_COMPONENT_TYPE_GET_REQUEST, GetSalaryComponentType);
    yield takeLatest(ActionTypes.PAYROLL_EARNING_GET_REQUEST, GetEarningComponent);
    yield takeLatest(ActionTypes.PAYROLL_DEDUCTION_GET_REQUEST, GetDeductionComponent);
    yield takeLatest(ActionTypes.PAYROLL_CUSTOM_EARNING_GET_REQUEST, GetCustomEarningComponent);
    yield takeLatest(ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_REQUEST, GetCustomDeductionComponent);
    yield takeLatest(ActionTypes.PAYROLL_TEMPLATE_GET_REQUEST, GetPayrollTemplate);
    yield takeLatest(ActionTypes.PAYROLL_TEMPLATE_ADD_REQUEST, AddPayrollTemplate);
    yield takeLatest(ActionTypes.PAYROLL_TEMPLATE_UPDATE_REQUEST, UpdatePayrollTemplate);
    yield takeLatest(ActionTypes.PAYROLL_TEMPLATE_DELETE_REQUEST, DeletePayrollTemplate);
    yield takeLatest(ActionTypes.EMPLOYEE_TEMPLATE_GET_REQUEST, GetEmployeeTemplate);
    yield takeLatest(ActionTypes.EMPLOYEE_TEMPLATE_ADD_REQUEST, AddEmployeeTemplate);
    yield takeLatest(ActionTypes.EMPLOYEE_TEMPLATE_UPDATE_REQUEST, UpdateEmployeeTemplate);
    yield takeLatest(ActionTypes.WAGE_REPORT_GET_REQUEST, GetWageReport);
    yield takeLatest(ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_REQUEST, GetWageReportNotProcessed);
    yield takeLatest(ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_REQUEST, GetContractualWageReport);
    yield takeLatest(ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST, GetContractualWageReportNotProcessed);
    yield takeLatest(ActionTypes.DAILY_WAGE_REPORT_GET_REQUEST, GetDailyWageReport);
    yield takeLatest(ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST, GetDailyWageReportNotProcessed);
    yield takeLatest(ActionTypes.EMPLOYEE_TIME_GET_REQUEST, GetEmployeeTime);
    yield takeLatest(ActionTypes.EMPLOYEE_FACE_TIME_GET_REQUEST, GetEmployeeFaceTime);
    yield takeLatest(ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_REQUEST, GetPayrollSettings);
    yield takeLatest(ActionTypes.LWF_ADD_REQUEST, AddLWF);
    yield takeLatest(ActionTypes.LWF_UPDATE_REQUEST, UpdateLWF);
    yield takeLatest(ActionTypes.LWF_DELETE_REQUEST, DeleteLWF);
    yield takeLatest(ActionTypes.OT_GET_REQUEST, GetOT);
    yield takeLatest(ActionTypes.OT_ADD_REQUEST, AddOT);
    yield takeLatest(ActionTypes.OT_UPDATE_REQUEST, UpdateOT);
    yield takeLatest(ActionTypes.OT_DELETE_REQUEST, DeleteOT);
    yield takeLatest(ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_REQUEST, CalculateEmployeeSalaryTemplate);
    yield takeLatest(ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_ADD_REQUEST, AddCalculateEmployeeSalaryTemplate);
    yield takeLatest(ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_GET_REQUEST, GetCalculateEmployeeSalaryTemplate);
    yield takeLatest(ActionTypes.PAY_DATE_GET_REQUEST, GetPayDate);
    yield takeLatest(ActionTypes.PAY_DATE_UPDATE_REQUEST, UpdatePayDate);
    yield takeLatest(ActionTypes.PAYROLL_APPROVER_GET_REQUEST, GetPayrollApprover);
    yield takeLatest(ActionTypes.PAYROLL_APPROVER_UPDATE_REQUEST, UpdatePayrollApprover);
    yield takeLatest(ActionTypes.PAYROLL_TILE_VIEW_GET_REQUEST, GetPayrollTileView);
    yield takeLatest(ActionTypes.LEAVE_WAGE_GET_REQUEST, GetLeaveWage);
    yield takeLatest(ActionTypes.LEAVE_WAGE_ADD_REQUEST, AddLeaveWage);
    yield takeLatest(ActionTypes.LEAVE_WAGE_UPDATE_REQUEST, UpdateLeaveWage);
    yield takeLatest(ActionTypes.LEAVE_WAGE_DELETE_REQUEST, DeleteLeaveWage);
    yield takeLatest(ActionTypes.TRANSPORT_ALLOWANCE_GET_REQUEST, GetTransportAllowance);
    yield takeLatest(ActionTypes.TRANSPORT_ALLOWANCE_ADD_REQUEST, AddTransportAllowance);
    yield takeLatest(ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_REQUEST, UpdateTransportAllowance);
    yield takeLatest(ActionTypes.TRANSPORT_ALLOWANCE_DELETE_REQUEST, DeleteTransportAllowance);
    yield takeLatest(ActionTypes.PH_ALLOWANCE_GET_REQUEST, GetPHAllowance);
    yield takeLatest(ActionTypes.PH_ALLOWANCE_ADD_REQUEST, AddPHAllowance);
    yield takeLatest(ActionTypes.PH_ALLOWANCE_UPDATE_REQUEST, UpdatePHAllowance);
    yield takeLatest(ActionTypes.PH_ALLOWANCE_DELETE_REQUEST, DeletePHAllowance);
    yield takeLatest(ActionTypes.BONUS_CONFIGURATION_GET_REQUEST, GetBonusConfiguration);
    yield takeLatest(ActionTypes.BONUS_CONFIGURATION_UPDATE_REQUEST, UpdateBonusConfiguration);
    yield takeLatest(ActionTypes.FOOD_ALLOWANCE_GET_REQUEST, GetFoodAllowance);
    yield takeLatest(ActionTypes.FOOD_ALLOWANCE_UPDATE_REQUEST, UpdateFoodAllowance);
    yield takeLatest(ActionTypes.ADJUSTMENT_COMPONENTS_GET_REQUEST, GetPostAdjustmentComponents);
    yield takeLatest(ActionTypes.ADJUSTMENT_COMPONENTS_ADD_REQUEST, AddPostAdjustmentComponents);
    yield takeLatest(ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_REQUEST, UpdatePostAdjustmentComponents);
    yield takeLatest(ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_REQUEST, DeletePostAdjustmentComponents);
    yield takeLatest(ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_REQUEST, GetPayrollReportingEmployee);
    yield takeLatest(ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_REQUEST, GetEmployeePostAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_REQUEST, AddEmployeePostAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_REQUEST, UpdateEmployeePostAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_REQUEST, DeleteEmployeePostAdjustment);
    yield takeLatest(ActionTypes.EXPENSE_TYPE_GET_REQUEST, GetExpenseType);
    yield takeLatest(ActionTypes.EXPENSE_TYPE_ADD_REQUEST, AddExpenseType);
    yield takeLatest(ActionTypes.EXPENSE_TYPE_UPDATE_REQUEST, UpdateExpenseType);
    yield takeLatest(ActionTypes.EXPENSE_TYPE_DELETE_REQUEST, DeleteExpenseType);
    yield takeLatest(ActionTypes.EXPENSE_SUBTYPE_GET_REQUEST, GetExpenseSubtype);
    yield takeLatest(ActionTypes.EXPENSE_SUBTYPE_ADD_REQUEST, AddExpenseSubtype);
    yield takeLatest(ActionTypes.EXPENSE_SUBTYPE_UPDATE_REQUEST, UpdateExpenseSubtype);
    yield takeLatest(ActionTypes.EXPENSE_SUBTYPE_DELETE_REQUEST, DeleteExpenseSubtype);
    yield takeLatest(ActionTypes.EMPLOYEE_EXPENSE_GET_REQUEST, GetEmployeeExpense);
    yield takeLatest(ActionTypes.EMPLOYEE_EXPENSE_ADD_REQUEST, AddEmployeeExpense);
    yield takeLatest(ActionTypes.EMPLOYEE_EXPENSE_UPDATE_REQUEST, UpdateEmployeeExpense);
    yield takeLatest(ActionTypes.EMPLOYEE_EXPENSE_DELETE_REQUEST, DeleteEmployeeExpense);
    yield takeLatest(ActionTypes.APPROVER_EXPENSE_GET_REQUEST, GetApproverExpense);
    yield takeLatest(ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_REQUEST, GetEmployeeExpenseCsv);
    yield takeLatest(ActionTypes.APPROVER_EXPENSE_UPDATE_REQUEST, UpdateApproverExpense);
    yield takeLatest(ActionTypes.REGISTRATION_NUMBER_GET_REQUEST, GetRegistrationNumber);
    yield takeLatest(ActionTypes.REGISTRATION_NUMBER_ADD_REQUEST, AddRegistrationNumber);
    yield takeLatest(ActionTypes.ECMS_COMPONENTS_GET_REQUEST, GetECMSComponents);
    yield takeLatest(ActionTypes.ECMS_COMPONENTS_ADD_REQUEST, AddECMSComponents);
    yield takeLatest(ActionTypes.ECMS_COMPONENTS_UPDATE_REQUEST, UpdateECMSComponents);
    yield takeLatest(ActionTypes.ECMS_COMPONENTS_DELETE_REQUEST, DeleteECMSComponents);
    yield takeLatest(ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET, GetEmployeeEcmsAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD, AddEmployeeEcmsAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE, UpdateEmployeeEcmsAdjustment);
    yield takeLatest(ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE, DeleteEmployeeEcmsAdjustment);

}